import { render, staticRenderFns } from "./UploadView.vue?vue&type=template&id=1d97eb12&scoped=true&"
import script from "./UploadView.vue?vue&type=script&lang=js&"
export * from "./UploadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d97eb12",
  null
  
)

export default component.exports